var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-box",
    {
      attrs: {
        "show-action-close": _vm.hasCloseButton,
        "is-visible": _vm.isVisible,
        title: _vm.modalTitle,
        "is-processing": _vm.isProcessing,
        "data-qa": "unauthenticated-follow-modal",
      },
      on: { "action-close": _vm.close, open: _vm.onOpen },
    },
    [
      _c(_vm.currentComponent, {
        tag: "component",
        attrs: { "return-url": _vm.returnUrl },
        on: { submit: _vm.onSubmit, close: _vm.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }